import { createReducer } from 'redux-act'

import State from './types'
import BaseTransport from '../../transports/common/base-transport'
import {
    startUserDetailsTransport,
    saveUserDetailsTransport,
    errorUserDetailsTransport,
    addFavoriteListing,
    removeFavoriteListing,
} from './actions'
import initialState from './state'
import UserDetailsTransport from '../../transports/user-details-transport'

const _startUserDetailsTransport = (state: State): State => ({
    ...state,
    userDetails: {
        ...state.userDetails,
        isLoading: true,
        error: null,
    },
})

const _saveUserDetailsTransport = (state: State, payload: BaseTransport<UserDetailsTransport>): State => ({
    ...state,
    userDetails: {
        ...state.userDetails,
        isLoading: false,
        transport: payload,
    },
})

const _errorUserDetailsTransport = (state: State, payload: Error): State => ({
    ...state,
    userDetails: {
        ...state.userDetails,
        isLoading: false,
        error: payload,
    },
})

const _addFavoriteListing = (state: State, listingId: string): State => {
    const transport = state.userDetails.transport
    if (!transport || !transport.data) {
        return state
    }

    const currentFavorites = transport.data.favoriteListings || []
    if (currentFavorites.includes(listingId)) {
        return state
    }

    const newFavourites = [...currentFavorites, listingId]

    return {
        ...state,
        userDetails: {
            ...state.userDetails,
            transport: {
                ...transport,
                data: {
                    ...transport.data,
                    favoriteListings: newFavourites,
                    favoriteCount: newFavourites.length,
                } as UserDetailsTransport,
            },
        },
    }
}

const _removeFavoriteListing = (state: State, listingId: string): State => {
    const transport = state.userDetails.transport
    if (!transport || !transport.data) {
        return state
    }

    const currentFavorites = transport.data.favoriteListings || []
    const newFavourites = currentFavorites.filter(id => id !== listingId)

    return {
        ...state,
        userDetails: {
            ...state.userDetails,
            transport: {
                ...transport,
                data: {
                    ...transport.data,
                    favoriteListings: newFavourites,
                    favoriteCount: newFavourites.length,
                } as UserDetailsTransport,
            },
        },
    }
}

const reducer = createReducer<State>(on => {
    on(startUserDetailsTransport, _startUserDetailsTransport)
    on(saveUserDetailsTransport, _saveUserDetailsTransport)
    on(errorUserDetailsTransport, _errorUserDetailsTransport)
    on(addFavoriteListing, _addFavoriteListing)
    on(removeFavoriteListing, _removeFavoriteListing)
}, initialState)

export default reducer
